// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium Select — полупрозрачный «стеклянный» выпадающий список ролей.
   Используется в админке (создание сотрудника) и на экране логина.
   Значения совпадают с исходным блоком в admin.css. */

.premium-select-container {
  position: relative;
  width: 100%;
}

.premium-select-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: rgba(248, 250, 252, 0.5);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary);
}

.premium-select-trigger:hover {
  background: white;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.premium-select-trigger .trigger-content {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
}

.premium-select-trigger .arrow-icon {
  transition: transform 0.3s ease;
}

.premium-select-trigger .arrow-icon.rotate {
  transform: rotate(180deg);
}

.premium-select-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: var(--bg-glass-heavy);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: 14px;
  box-shadow: var(--shadow-lg, 0 24px 60px rgba(15, 23, 42, 0.28));
  z-index: 100;
  overflow: hidden;
  padding: 6px;
}

.premium-select-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: none;
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.premium-select-option:hover {
  background: rgba(59, 130, 246, 0.1);
}

.premium-select-option.active {
  background: var(--accent-primary);
  color: white;
}

.premium-select-option .option-text {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.premium-select-option .option-label {
  font-weight: 700;
  font-size: 0.95rem;
}

.premium-select-option .option-desc {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

/* Тёмная тема: триггер не должен быть белесым */
:root[data-theme='dark'] .premium-select-trigger {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

:root[data-theme='dark'] .premium-select-trigger:hover {
  background: var(--bg-tertiary);
  border-color: var(--accent-hover);
}
`, "",{"version":3,"sources":["webpack://./src/css/premium-select.css"],"names":[],"mappings":"AAAA;;sDAEsD;;AAEtD;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,eAAe;EACf,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,gEAAgE;EAChE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC","sourcesContent":["/* Premium Select — полупрозрачный «стеклянный» выпадающий список ролей.\n   Используется в админке (создание сотрудника) и на экране логина.\n   Значения совпадают с исходным блоком в admin.css. */\n\n.premium-select-container {\n  position: relative;\n  width: 100%;\n}\n\n.premium-select-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background: rgba(248, 250, 252, 0.5);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--text-primary);\n}\n\n.premium-select-trigger:hover {\n  background: white;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.premium-select-trigger .trigger-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 600;\n}\n\n.premium-select-trigger .arrow-icon {\n  transition: transform 0.3s ease;\n}\n\n.premium-select-trigger .arrow-icon.rotate {\n  transform: rotate(180deg);\n}\n\n.premium-select-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  background: var(--bg-glass-heavy);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: 14px;\n  box-shadow: var(--shadow-lg, 0 24px 60px rgba(15, 23, 42, 0.28));\n  z-index: 100;\n  overflow: hidden;\n  padding: 6px;\n}\n\n.premium-select-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.premium-select-option:hover {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.premium-select-option.active {\n  background: var(--accent-primary);\n  color: white;\n}\n\n.premium-select-option .option-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.premium-select-option .option-label {\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.premium-select-option .option-desc {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n/* Тёмная тема: триггер не должен быть белесым */\n:root[data-theme='dark'] .premium-select-trigger {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .premium-select-trigger:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--accent-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
